export const MAX_CARD_WIDTH = '364px';
